function TopHead() {
  return (
    <>
      <>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
        <link
          href="https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200..1000;1,200..1000&display=swap"
          rel="stylesheet"
        />
      </>
      <div className="whole">
        <div className="row">
          <div className="first_four_images col-3 d-flex justify-content-evenly mt-1">
            <a href="">
              <img
                id="LFE"
                src="images\04-Life final logo.png"
                alt="LFE"
                width="105"
                height="55"
                style={{ marginTop: "10px", marginLeft: "4px" }}
              />
            </a>
            <a href="">
              <img
                id="G20"
                src="images\G20_India_2023_logo.png"
                alt="G20"
                width="95"
                height="65"
                style={{ marginTop: "5px", marginLeft: "8px" }}
              />
            </a>
            <a href="">
              <img
                id="EIACP"
                src="images\EIACP_Logo.png"
                alt="EIACP"
                width="63"
                style={{ marginTop: "5px", marginLeft: "8px" }}
              />
            </a>
            <a href="">
              <img
                id="ENVIS"
                src="images\ENVIS Logo_FINAL.png"
                alt="ENVIS"
                width="63"
                style={{ marginTop: "1px", marginLeft: "8px" }}
              />
            </a>
          </div>
          <div className="heading col-6" style={{ marginLeft: "0px" }}>
            <h5
              style={{
                textAlign: "center",
                fontFamily: "'Nunito'",
                color: "black ",
                marginTop: "7px",
                marginLeft: "20px",
              }}
            >
              <b>
                INSIGHTS INTO THE LINKAGES OF FOREST STRUCTURE DYNAMICS WITH
                ECOSYSTEM SERVICES
              </b>
              <br />

              <div style={{ fontSize: "0.7em" }}>
                <strong>
                  <a id="searchlink1" href="#" rel="subcontent1">
                    T.V. Ramachandra<sup>1,2,3*</sup>
                  </a>
                  &nbsp;
                  <a id="searchlink2" href="#" rel="subcontent2">
                    Paras Negi<sup>1,4</sup>
                  </a>
                  &nbsp;
                  <a id="searchlink3" href="#" rel="subcontent3">
                    Tulika Mondal<sup>1,4</sup>
                  </a>
                  &nbsp;
                  <a id="searchlink4" href="#" rel="subcontent4">
                    Syed Ashfaq Ahmed<sup>1</sup>
                  </a>
                </strong>
              </div>
              <div style={{ fontSize: "0.54em" }} className="style33">
                <span className="style16">
                  <sup>1</sup>Energy and Wetlands Research Group, Centre for
                  Ecological Sciences [CES],
                  <br />
                  <sup>2</sup>Centre for Sustainable Technologies (astra),
                  <br />
                  <sup>3</sup>Centre for&nbsp;
                  <em>Infrastructure</em>, Sustainable Transport and Urban
                  Planning [C<em>i</em>STUP], Indian Institute of Science,
                  Bangalore &ndash; 560012, India,
                  <br />
                  <sup>4</sup>Department of Applied Geology, Kuvempu University,
                  Shimoga 577471, India *Corresponding author:
                </span>
                <span className="style16">
                  &nbsp;
                  <a
                    title="mailto:tvr@iisc.ac.in"
                    href="mailto:tvr@iisc.ac.in"
                  >
                    tvr@iisc.ac.in
                  </a>
                </span>
              </div>
            </h5>
          </div>

          <div
            style={{
              filter: "brightness(100%)",
              mixBlendMode: "multiply",
              marginTop: "7px",
              marginRight: "0px",
            }}
            className="col-3 second_four_images  d-flex justify-content-evenly mt-1"
          >
            <a href="">
              <img
                id="IISc"
                src="images\IISc_Master_Seal.jpg"
                alt="IISc"
                width="78"
              />
            </a>
            <a href="">
              <img src="images\EWRG_logo.jpeg" alt="EWRG" width="70" />
            </a>
            <a href="">
              <img
                id="NE"
                src="images\National Emblem (1).png"
                alt=""
                width="60"
                style={{ marginTop: "3px" }}
              />
            </a>
            <a href="">
              <img
                src="images/Aazadi_ka_amrit_mahotsav_logo.png"
                alt="AKAM"
                width="100"
                height="65"
                style={{ marginTop: "5px" }}
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
export default TopHead;
